import {
  addTemplate,
  getTemplates,
  getCampaigns,
  getTemplate,
  updateTemplate,
  getSegments,
  getSegmentsSubscribers,
  getFlows,
  getFlowSequence,
  getMenuItem,
  getOtherCampaigns,
  getCampaignList,
  getCampaignListV2,
  getSegmentObj
} from "@/api/campaigns";

export default {
  async addTemplate({ state }) {
    const payload = JSON.parse(
      JSON.stringify({
        name: state.formData.templateName,
        export_html: state.templateDesign,
        html_content: state.templateData.html,
        text_content: state.templateData.html
      })
    );
    const response = await addTemplate(payload);
    return response;
  },
  async updateTemplate({ state }) {
    const payload = JSON.parse(
      JSON.stringify({
        name: state.formData.templateName,
        export_html: state.templateDesign,
        html_content: state.templateData.html,
        text_content: state.templateData.html
      })
    );
    const response = await updateTemplate(state.templateId, payload);
    return response;
  },
  async getTemplates({ commit }) {
    const response = await getTemplates();
    commit("setTemplates", response);
  },
  async getCampaigns({ state, commit }) {
    const response = await getCampaigns(state.formData);
    commit("setCampaigns", response);
  },
  async getTemplate({ state, commit }) {
    const response = await getTemplate(state.templateId);
    commit("setTemplate", response);
  },
  async getSegments({ commit }) {
    const response = await getSegments();
    commit("setSegments", response);
  },
  async getSegmentsSubscribers({ state, commit }) {
    const response = await getSegmentsSubscribers(state.segment.id);
    commit("setSegmentSubscribers", response);
  },
  async getFlows({ commit }) {
    const response = await getFlows();
    commit("setFlows", response);
  },
  async getFlowSequence({ state, commit }) {
    const response = await getFlowSequence(state.flowId);
    commit("setFlowSequence", response);
  },
  async getInitialMenuItems({ state, commit }) {
    const location_id = state.campaignSelectedLocations;
    if (typeof location_id !== "undefined" && location_id) {
      const response = await getMenuItem({ location_id: location_id.id });
      commit("setInitialMenuItems", response);
    } else {
      commit("setInitialMenuItems", null);
    }
  },
  async getOtherCampaignItems({ commit }) {
    const response = await getOtherCampaigns();
    commit("setOtherCampaignItems", response);
  },
  async getCampaignList({ commit }) {
    const response = await getCampaignList();
    commit("setCampaigns", response);
  },
  async getCampaignListV2({ commit }) {
    const response = await getCampaignListV2();
    commit("setCampaigns", response);
  },
  async getSegmentObj({ commit, state }) {
    console.log("state.segment.id", state.segment.id);
    const response = await getSegmentObj(state.segment.id);
    commit("setSegmentObj", response);
  }
};
